export class RegisterNotAllFieldsFilledInError extends Error {

  code?: string = 'auth/not-all-fields-filled-in';
}
